import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M26,8.59,20.41,3A3.733,3.733,0,0,0,18,2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V11A3.733,3.733,0,0,0,26,8.59ZM19,4.41,24.59,10H19ZM25,28H7V4H17v7a1,1,0,0,0,1,1h7Z"/><path d="M21.5,14h-11A1.5,1.5,0,0,0,9,15.5v9A1.5,1.5,0,0,0,10.5,26h11A1.5,1.5,0,0,0,23,24.5v-9A1.5,1.5,0,0,0,21.5,14ZM15,18h6v2H15Zm-2,6H11V22h2Zm0-4H11V18h2Zm8,4H15V22h6Z"/>';
export var FileSpreadsheetOutlineSVG = function FileSpreadsheetOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FileSpreadsheetOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FileSpreadsheetOutlineSVG);